import { useState } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import Landing from "@/pages/Landing";
import Sidebar from "@/components/layout/Sidebar";
import TopNav from "@/components/layout/TopNav";
import AIChat from "@/components/AIChat";
import ChatNotifier from "@/components/ChatNotifier";
import { useAuth } from "@/context/AuthContext";
import { useBranchView } from "@/context/BranchViewContext";
import { Toaster } from "@/components/ui/sonner";

export default function AppLayout() {
  const { user } = useAuth();
  const [aiOpen, setAiOpen] = useState(false);
  const { selected: branchView } = useBranchView();
  const { pathname } = useLocation();

  // Logged-out visitors land on the public PRIZM page at "/"; every other protected URL goes to sign-in.
  if (!user) return pathname === "/" ? <Landing /> : <Navigate to="/login" replace />;

  return (
    <div className="min-h-screen flex">
      <div className="app-bg" />
      <Sidebar />
      <div className="flex-1 min-w-0 flex flex-col">
        <TopNav onOpenAI={() => setAiOpen(true)} />
        <main className="flex-1 p-6 lg:p-8 max-w-[1600px] w-full mx-auto">
          {/* Re-mount the page when the branch view changes so every screen refetches with the new scope */}
          <Outlet key={branchView || "none"} />
        </main>
      </div>
      <AIChat open={aiOpen} onClose={() => setAiOpen(false)} />
      <ChatNotifier />
      <Toaster />
    </div>
  );
}
